import { Fab, Grid, IconButton, Stack } from '@mui/material';

import DateRangePicker from './DatePicker';

import { ReactComponent as RightArrow } from '@src/assets/icons/layup/arrow_forward.svg';
import { ReactComponent as LeftArrow } from '@src/assets/icons/layup/arrow_back.svg';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import dayjs from 'dayjs';
import { FIXED_DATE_RANGE_DAYS } from '../LayingUp';
import {
  LAYUP_STATUS_OPTION,
  LayUpStatuses,
  LayUpStatusFilter,
} from '@src/constants/LayupStatuses';
import Dropdown from '@src/components/DropDown';

interface Prop {
  setDate: React.Dispatch<React.SetStateAction<string>>;
  date: string;
  setStatus: React.Dispatch<React.SetStateAction<LayUpStatusFilter>>;
  status: string;
  handleOpen: () => void;
}

export const LAYUP_STATUS_OPTIONS: { id: LayUpStatusFilter; name: string }[] = [
  { id: 'All', name: 'All' },
  ...(Object.keys(LAYUP_STATUS_OPTION) as LayUpStatuses[]).map((id) => ({
    id,
    name: LAYUP_STATUS_OPTION[id],
  })),
];

function SearchLayingUpBox({
  setDate,
  date,
  setStatus,
  status,
  handleOpen,
}: Prop) {
  const handleRange = (direction: 1 | -1) => {
    setDate((prev) =>
      dayjs(prev)
        .add(direction * FIXED_DATE_RANGE_DAYS, 'day')
        .format('YYYY-MM-DD')
    );
  };

  const handleChange = (id: string | number | (string | number)[] | null) => {
    setStatus(id as LayUpStatusFilter);
  };

  return (
    <Grid container spacing={1} alignItems="center" sx={{ mt: '33px' }}>
      <Grid item xs={2} md={2}>
        <DateRangePicker value={date} onChange={setDate} />
      </Grid>

      <Grid item xs={'auto'} md={'auto'}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          spacing={1}>
          <Fab
            color="primary"
            size="small"
            aria-label="previous range"
            onClick={() => handleRange(-1)}>
            <LeftArrow />
          </Fab>
          <Fab
            color="primary"
            size="small"
            aria-label="previous range"
            onClick={() => handleRange(1)}>
            <RightArrow />
          </Fab>
        </Stack>
      </Grid>

      <Grid item xs={2} md={2}>
        <Dropdown
          size={'small'}
          options={LAYUP_STATUS_OPTIONS}
          label={'Status'}
          onChange={handleChange}
          value={status}
        />
      </Grid>

      <Grid item sx={{ marginLeft: 'auto' }}>
        <IconButton
          onClick={handleOpen}
          sx={{
            color: 'primary',
            size: 'small',
            borderRadius: '8px',
            border:
              '1px solid var(--Primary-States-Outlined-Resting-Border, #5046E5)',
          }}>
          <UnfoldMoreIcon color="primary" />
        </IconButton>
      </Grid>
    </Grid>
  );
}

export default SearchLayingUpBox;
